import React from 'react';
import moment from 'moment';
import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';

function RenderMonthHeader({ _month }) {
	const _moment = moment().clone().set('month', _month);
	const currMonth = _moment.format('MMMM');
	const currYear = _moment.format('YYYY');
	return (
		<Box className="month-box">
			<Box
				style={{
					color: 'black',
					textAlign: 'center',
					width: '100%',
					fontSize: 14,
					fontFamily: 'bogle-bold',
					lineHeight: '20px',
				}}>{`${currMonth} ${currYear}`}</Box>
		</Box>
	);
}

RenderMonthHeader.propTypes = {
	_month: PropTypes.number,
};

export default RenderMonthHeader;
